import React, { FC } from 'react';
import Popover from '../../../../../common/popover/popover';
import { ReactComponent as SchoolIcon } from '../../../../../images/header/school-gradient.svg';
import translation from '../../../../../languages';
import SchoolsBurgerMenu from './components/schools-burger-menu';
import './schools-burger.scss';

const SchoolsBurger: FC<TranslationProps> = ({ t }) => {
    return (
        <div className='schools-burger'>
            <Popover
                trigger='click'
                menu={<SchoolsBurgerMenu />}
                triggerAs={
                    <div id='schools-burger-button' className='schools-burger-button'>
                        <SchoolIcon />
                        <div className='tsc-caption'>{t('header.icons.materials')}</div>
                    </div>
                }
            />
        </div>
    );
};

const translate = translation('header');

export default translate(SchoolsBurger);
